/*
 * 1DS JS SDK QoS plugin, 3.1.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* id.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2018
*/
import { createGuid } from "@microsoft/1ds-core-js";
var Id = /** @class */ (function () {
    function Id() {
        this.lastPageViewId = createGuid();
        this.traceId = this.createTraceId();
    }
    Id.prototype.createTraceId = function () {
        return createGuid().replace(/-/g, "");
    };
    Id.prototype.getTraceId = function () {
        return this.traceId;
    };
    Id.prototype.getLastPageViewId = function () {
        return this.lastPageViewId;
    };
    return Id;
}());
export default Id;
//# sourceMappingURL=Id.js.map